import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VeeValidate from 'vee-validate'


Vue.config.productionTip = false;
/**
 * Vue filter to round the decimal to the given place.
 * http://jsfiddle.net/bryan_k/3ova17y9/
 *
 * @param {String} value    The value string.
 * @param {Number} decimals The number of decimal places.
 */
Vue.prototype.$minLoan=5000;
Vue.prototype.$apiURL="https://us-central1-tfsweb-212204.cloudfunctions.net/api/v1";
//Vue.prototype.$apiURL="http://localhost:8000/v1";
Vue.prototype.$buttonValues= {
    PRIVATE: "Private",
    BUSINESS: "Business",
    RENTING: "Renting / Other",
    OWNER:"Property Owner",
    NEW:"New/Demo",
    USED:"Used",
    GOOD:"Good",
    AVERAGE:"Average",
};
Vue.filter('round', function(value, decimals) {
    if(!value) {
        value = 0;
    }

    if(!decimals) {
        decimals = 0;
    }

    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    return value;
});
Vue.use(VeeValidate);


Vue.prototype.$http=axios;
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


